export * from './element-create.component';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/web-targets/element-create/index.ts